import React from 'react';
import AudioManager from '../audio/AudioManager';
// For demonstration, 32 piano‐roll rows, and a large number of columns
// (e.g. 64 time steps) to illustrate horizontal scrolling. Adjust as needed.
const TOTAL_NOTES = 20;
// A simple 12‐note pattern for black/white keys:
const PIANO_PATTERN = [
    false, // C
    true, // C#
    false, // D
    true, // D#
    false, // E
    false, // F
    true, // F#
    false, // G
    true, // G#
    false, // A
    true, // A#
    false, // B
];
function NoteGrid({ grid, onToggleCell, trackColour, instrument }) {
    const audioManager = AudioManager.getInstance();
    const playNote = (rowIndex) => {
        const baseFrequency = 261.63;
        const frequency = baseFrequency * Math.pow(2, rowIndex / 12);
        audioManager.playNote(instrument, frequency, -1); // -1 for indefinite duration
    };
    const stopNote = () => {
        audioManager.stopNote(instrument);
    };
    return (React.createElement("div", { className: "w-full bg-gray-800 border border-gray-700 rounded p-4" }, grid.slice().reverse().map((row, rowIndex) => {
        const actualRowIndex = TOTAL_NOTES - 1 - rowIndex;
        const isBlack = PIANO_PATTERN[actualRowIndex % 12];
        return (React.createElement("div", { key: actualRowIndex, className: "flex items-center mb-1" },
            React.createElement("div", { className: `w-6 h-6 border ${isBlack ? 'bg-black' : 'bg-white'}`, style: { borderColor: trackColour || '#fff' }, onMouseDown: () => playNote(actualRowIndex), onMouseUp: stopNote, onMouseLeave: stopNote }),
            React.createElement("div", { className: "flex flex-nowrap overflow-x-auto ml-3 space-x-1" }, row.map((isActive, colIndex) => (React.createElement("div", { key: colIndex, onClick: () => onToggleCell(actualRowIndex, colIndex), className: `w-6 h-6 border border-gray-600 cursor-pointer
                    ${isActive ? 'bg-orange-600' : 'bg-gray-700'} 
                    hover:bg-orange-500 transition-all` }))))));
    })));
}
export default NoteGrid;
